import { render } from "./TodoHeader.vue?vue&type=template&id=7c8c7bb7&scoped=true"
import script from "./TodoHeader.vue?vue&type=script&lang=js"
export * from "./TodoHeader.vue?vue&type=script&lang=js"

import "./TodoHeader.vue?vue&type=style&index=0&id=7c8c7bb7&scoped=true&lang=css"

import exportComponent from "/home/bammer/vue/doit-vue/vue-todo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8c7bb7"]])

export default __exports__